import { isNone } from '@ember/utils';
export function makeCatalogEvent(catalogName, params) {
  return Object.assign({
    catalog_name: catalogName
  }, params);
}
export function makeCatalogEventCreator(defaultParams) {
  return function (params = {}) {
    return Object.assign(defaultParams, params);
  };
}
export function pageClickEventCreator(action, description, params = {}) {
  if (isNone(action) || isNone(description)) {
    throw new Error('Must define action and description when tracking page click event');
  }
  const event = Object.assign({
    catalog_name: 'page_click',
    page_click_action: action,
    page_click_description: description
  }, params);

  // toString() allows for easier debugging and for using event objects
  // as keys in objects.
  Object.defineProperty(event, 'toString', {
    enumerable: false,
    value() {
      return `page_click ${action} ${description}`;
    }
  });
  return event;
}
export function pageViewEventCreator(description) {
  if (isNone(description)) {
    throw new Error('Must define description when tracking page view event');
  }
  const event = {
    catalog_name: 'page_view',
    page_view_description: description
  };

  // toString() allows for easier debugging and for using event objects
  // as keys in objects.
  Object.defineProperty(event, 'toString', {
    enumerable: false,
    value() {
      return `page_view ${description}`;
    }
  });
  return event;
}
export function buttonClickEvent(description, params = {}) {
  return pageClickEventCreator('button-click', description, params);
}
export function linkClickEvent(description, params = {}) {
  return pageClickEventCreator('link-click', description, params);
}
export function showEvent(description, params = {}) {
  return pageClickEventCreator('show', description, params);
}
export function inputEvent(description, params = {}) {
  return pageClickEventCreator('input', description, params);
}
export function hoverEvent(description, params = {}) {
  return pageClickEventCreator('hover', description, params);
}
export function dropdownOpenEvent(description, params = {}) {
  return pageClickEventCreator('dropdown-open', description, params);
}
export function modalOpenEvent(description, params = {}) {
  return pageClickEventCreator('modal-open', description, params);
}
export function modalCloseEvent(description, params = {}) {
  return pageClickEventCreator('modal-close', description, params);
}
export function dragEvent(description, params = {}) {
  return pageClickEventCreator('drag', description, params);
}
export function toggleEvent(description, params = {}) {
  return pageClickEventCreator('toggle', description, params);
}
export function prependCatalogName(object, catalogName) {
  const objectNew = {};
  for (const property in object) {
    objectNew[`${catalogName}_${property}`] = object[property];
  }
  return objectNew;
}